import {call_get, SHAPE_API_THEN, usingCancelToken} from "./api";
import {crmPartners} from "./root";

export const getPartners = () => {
    const others = {...usingCancelToken("tokenGetPartners")}
    return SHAPE_API_THEN(call_get(crmPartners, null, others), false, true)
}
